import React from 'react';

/**
 * Separador que indica desde qué número se INICIÓ la conversación de WhatsApp.
 * Se muestra delante del primer mensaje (complementa al PhoneChangeSeparator,
 * que solo aparece cuando el número cambia más adelante).
 */
const PhoneStartSeparator = ({ phoneName }) => {
  if (!phoneName) return null;

  return (
    <div className='flex items-center justify-center my-3'>
      <div className='flex items-center gap-2 w-full max-w-md'>
        <div className='flex-1 h-px bg-gray-300'></div>
        <div className='bg-emerald-50 border border-emerald-200 text-emerald-700 text-xs px-3 py-1 rounded-full whitespace-nowrap'>
          📱 Conversación iniciada desde {phoneName}
        </div>
        <div className='flex-1 h-px bg-gray-300'></div>
      </div>
    </div>
  );
};

export default PhoneStartSeparator;
